import { observer } from 'mobx-react-lite'
import { type SubmissionViewModel } from '@/features/jobs/drafting/SubmissionViewModel'
import { Submission } from '@/features/jobs/drafting/components/JobCreation/Submission'
import {
  AdminBillingContainer,
  BillingContainer,
} from '@/features/jobs/drafting/components/JobCreation/Submission/Billing/BillingContainer'
import { CouponSelectionContainer } from '@/features/jobs/drafting/components/JobCreation/Submission/CouponSelection/CouponSelectionContainer'
import { SubmissionStatusModalContainer } from '@/features/jobs/drafting/components/JobCreation/Submission/SubmissionStatusModal/SubmissionStatusModalContainer'

export interface SubmissionContainerProps {
  vm: SubmissionViewModel
  shadow?: boolean
}

export const SubmissionContainer = observer(function SubmissionContainer({
  vm,
  shadow,
}: SubmissionContainerProps) {
  const testId = 'draft-editor'
  const shouldCollectPaymentInfo = vm.billing.shouldCollectPaymentInfo

  const billingSection = shouldCollectPaymentInfo ? (
    vm.billing.canBypassBilling ? (
      <AdminBillingContainer vm={vm.billing} />
    ) : (
      <BillingContainer vm={vm.billing} testId={testId} />
    )
  ) : null

  // NOTE: The location of the coupon component in the tree differs
  // based on whether there is a selected coupon.
  const couponSection = vm.billing.isAppliedCouponShown && (
    <CouponSelectionContainer vm={vm.billing.couponSelection} testId={testId} />
  )
  const emptyCouponSection = vm.billing.isCouponPickerShown && (
    <CouponSelectionContainer vm={vm.billing.couponSelection} testId={testId} />
  )

  return (
    <Submission
      shadow={shadow}
      isLoading={vm.isLoading}
      shouldCollectPaymentInfo={shouldCollectPaymentInfo}
      pricing={vm.pricing}
      billingSection={billingSection}
      couponSection={couponSection}
      emptyCouponSection={emptyCouponSection}
      canSubmit={vm.canSubmit}
      isSubmitPending={vm.submit.pending}
      onSubmit={vm.submit}
      isAllowedToSubmit={vm.isAllowedToSubmit}
      statusModal={<SubmissionStatusModalContainer vm={vm.submissionStatus} />}
      testId={testId}
    />
  )
})
